
import {filterEditableOptions} from './editable-defs'

export default {
  props: {
    activeToken: {type: Object, default: undefined},
    options: {type: Array, default: () => []}
  },
  emits: ['keep-focus', 'select'],
  data() {
    return {
      active_idx: 0,
      visible: false
    }
  },
  computed: {
    is_empty() {
      return this.activeToken?.text?.length === 1 && this.visible
    },
    items() {
      return filterEditableOptions(this.activeToken, this.options)
    }
  },
  watch: {
    items() {
      this.active_idx = 0
    }
  },
  mounted() {
    window.addEventListener('keydown', this.onGlobalKeydown)
    this.openDropdown()
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onGlobalKeydown)
  },
  methods: {
    onGlobalKeydown(ev) {
      if (!['ArrowDown', 'ArrowUp', 'Enter'].includes(ev.key) || this.items.length === 0) return

      ev.preventDefault()
      ev.stopPropagation()
      this.keepFocus()
      
      if(ev.key === 'Enter') {
        this.$emit('select', this.items[this.active_idx])
        return
      }

      const direction = ev.key === 'ArrowDown' ? 1 : -1
      this.active_idx = (this.active_idx + direction + this.items.length) % this.items.length
    },
    keepFocus() {
      this.$emit('keep-focus')
    },
    async openDropdown() {
      await this.$nextTick()
      this.$refs.dropdown?.handleOpen()
    }
  }
}
